module.exports = __webpack_public_path__ + "img/content_copy.svg";